<template>
  <div class="w-100">
    <ProductCartPrimaryStyle
      v-if="page === 'CART'"
      :products="products"
      @removeProduct="removeProduct"
     />
     <ProductCartLightStyle
      v-if="page === 'SEARCH'"
      :products="products"
      :bg-color="bgColor"
      @removeProduct="removeProduct"
     />
     <ProductCartWhiteStyle
      v-if="page === 'CART-ADDITIONAL'"
      :products="products"
      :hide-remove="hideRemove"
      @removeProduct="removeProduct"
     />
  </div>
</template>

<script>
  import moment from 'moment';
  import { mapGetters,mapMutations } from 'vuex';
  import ProductCartPrimaryStyle from './ProductCartPrimaryStyle.vue';
  import ProductCartLightStyle from './ProductCartLightStyle.vue';
  import ProductCartWhiteStyle from './ProductCartWhiteStyle.vue';

  export default {
    components:{
      ProductCartPrimaryStyle,
      ProductCartLightStyle,
      ProductCartWhiteStyle
    },
    props: {
      page: {
        type: String,
        default: "CART"
      },
      bgColor: {
        type: String,
        default: "bg-light"
      },
      hideRemove: {
        type: Boolean,
        default: true
      }
    },
    computed:{
      ...mapGetters([
        'getMerchant',
        'getBeCartAddtService',
        'getActivityTrxProducts',
        'getOutletTrxProducts',
        'getVoucherOrder'
      ]),
      products(){
        let all_product = []
        
        // ORIGINAL
        this.getBeCartAddtService.forEach(original => {

          let {image_url,name,price,unit,category } = original.data

          let new_data = {
            type: 'ORIGINAL',
            module: category.name,
            ref_data: original,
            image_url: image_url,
            name: name,
            price: this.$formatCurrency(price),
            base_price: this.$formatCurrency(price),
            price_per_unit: this.$formatCurrency(price),
            qty: original.qty,
            unit: this.$isNotEmpty(unit) ? unit.unit : "",
            other: ''
          }

          if(this.$isNotEmpty(unit)) new_data.price_per_unit += ` / ${unit.unit}`

          all_product.push(new_data)
        });

        // SPA/ACTIVITY
        this.getActivityTrxProducts.forEach(activity=>{
          let {
            image_url,
            image_list,
            name,
            guest_include,
            product_merchant_pos
          } = activity.original_data

          let new_data = {
            type: 'ACTIVITY',
            module: this.$isNotEmpty(product_merchant_pos) ? product_merchant_pos[0].name : "",
            ref_data: activity,
            image_url: image_list.length == 0 ? image_url : image_list[0].image_url,
            name: name,
            price: this.$formatCurrency(activity.base_price.display.final),
            base_price: this.$formatCurrency(activity.base_price.base),
            price_per_unit: this.$formatCurrency(activity.base_price.display.final),
            unit: '', 
            qty: activity.qty
          }

          if(this.$isNotEmpty(guest_include)){
            let unitPrice = guest_include == 1 ? `per person` : `per ${guest_include} people`
            new_data.price_per_unit += ` / ${unitPrice}`

            new_data.unit = guest_include == 1 ? 'Person' : 'Package'
          }

          const serviceDateRaw = moment(activity.service_date).format("YYYY-MM-DD")
          const serviceDateTime = moment(`${serviceDateRaw} ${activity.service_time.schedule_start}`, 'YYYY-MM-DD HH:mm:ss')
          new_data.other = this.$formatDateTime(serviceDateTime);
          
          all_product.push(new_data)
        })

        // OUTLET
        this.getOutletTrxProducts.forEach(outlet=>{
          let is_variant = outlet.variants.length > 0

          let assignProduct = (variant=null) => {
            let {
              image_url,
              name,
              price,
              product_merchant_pos,
              product_pos,
              unit
            } = outlet.product_data

            const getProductModule = () => {
              if(is_variant) return this.$isNotEmpty(product_pos) ? product_pos[0].name : ""

              return this.$isNotEmpty(product_merchant_pos) ? product_merchant_pos[0].name : ""
            }

            let new_data = {
              type: 'OUTLET',
              module: getProductModule(),
              ref_data: outlet,
              ref_data_variant: is_variant ? variant.variant_data : {},
              image_url: image_url,
              name: !is_variant ? name : `${variant.variant_data.name} - ${name}`,
              price_per_unit: !is_variant ? price.price_sell_final_with_tax_service : variant.variant_data.price.price_sell_final_with_tax_service,
              qty: !is_variant ? outlet.qty : variant.qty,
              other: ''
            }

            new_data.price = this.$formatCurrency(new_data.price_per_unit)
            new_data.base_price = this.$formatCurrency(new_data.price_per_unit)
            new_data.price_per_unit = this.$formatCurrency(new_data.price_per_unit)
            new_data.unit = this.$isNotEmpty(unit) ? unit.unit : ''
            
            all_product.push(new_data)
          }

          if(is_variant){
            outlet.variants.forEach(outlet_variant=>{
              assignProduct(outlet_variant)
            })
          }else{
            assignProduct()
          }
        })

        // VOUCHER
        this.getVoucherOrder.cart.forEach(voucher_parent=>{
          voucher_parent.product.forEach(voucher=>{
            let {data,qty,is_variant,variant_list} = voucher
  
            let assignProduct = (variant=null) => {
              let {
                image_url,
                name,
                price,
                unit
              } = data
  
              let new_data = {
                type: 'VOUCHER',
                module: 'Voucher',
                ref_data: voucher,
                ref_data_variant: is_variant ? variant.data : {},
                image_url: image_url,
                name: !is_variant ? name : `${variant.data.name} - ${name}`,
                price_per_unit: !is_variant ? this.$calculateFinalPriceConcierge(price) : this.$calculateFinalPriceConcierge(variant.data.price),
                qty: !is_variant ? qty : variant.qty,
                other: ''
              }
  
              new_data.price = this.$formatCurrency(new_data.price_per_unit)
              new_data.base_price = this.$formatCurrency(new_data.price_per_unit)
              new_data.price_per_unit = this.$formatCurrency(new_data.price_per_unit)
              new_data.unit = this.$isNotEmpty(unit) ? unit.unit : ''
              
              all_product.push(new_data)
            }
  
            if(is_variant){
              variant_list.forEach(outlet_variant=>{
                assignProduct(outlet_variant)
              })
            }else{
              assignProduct()
            }
          })
          
        })
        
        return all_product
      }
    },
    methods:{
      ...mapMutations([
        'BeRemoveAddtService',
        'removeTrxActivityProduct',
        'removeTrxOutletProduct',
        'removeVoucherOrder'
      ]),
      removeProduct(product){
        let {type,ref_data,ref_data_variant} = product
        if(type == 'ORIGINAL'){
          this.BeRemoveAddtService(ref_data.data)
        }else if(type == 'ACTIVITY'){
          this.removeTrxActivityProduct({
            product: ref_data.original_data
          })
        }else if(type == 'OUTLET'){
          let is_variant = ref_data.variants.length > 0
          let params = {
            product: ref_data.product_data,
            variant: is_variant ? ref_data_variant : [],
            ref:  is_variant ? 'variant' : 'product',
            qty: product.qty,
            notes: product.notes
          }
          this.removeTrxOutletProduct(params)
        }else if(type == 'VOUCHER'){
          let params = {
            product: ref_data.data,
            variant: ref_data_variant
          }
          this.removeVoucherOrder(params)
        }
      }
    }
  }
</script>
<style>
  .addt_srv_cart .image{
    width: 85px;
    height: 75px;
    border-radius: 6px;
    overflow: hidden;
    flex-shrink: 0;
  }
  .addt_srv_cart .remove-btn{
    cursor: pointer;
    flex-shrink: 0;
    border-radius: 6px;
    background-color: #FFF;
    height: 40px; 
    width: 40px; 
    display: grid;
    place-items: center;
  }
</style>


// WEBPACK FOOTER //
// src/components/hotel/be/additionalService/ProductCart.vue